<template>
    <div class="component rotation-blocker">
        <div class="wrapper wrapper-large">
            <div class="copy">
                <div class="major-heading">Oops.</div>
                <p>Please rotate your device.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LandscapeBlocker',
};
</script>


<style scoped lang="scss">
.component {
    display: none;

    @media (max-width: breakpoint('medium')) and (orientation: landscape) {
        display: block;
        position: fixed;
        width: 100%;
        height: 100vh;
        background: #ffffff;
        z-index: 3;
        text-align: center;

        .wrapper {
            height: 100vh;
            @include flex($align-items: center, $justify-content: center);
        }
    }
}
</style>
